import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import {isMobile} from 'react-device-detect';
import BtnWhiteBlackBorderBigSize from '../../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import ContactUsAction from 'app/Components/Shared/ContactUs/ContactUsAction';
import EpiContext from '@episerver/spa-core/Spa';
import {connect} from 'react-redux';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import {showAppLoader, hideAppLoader} from 'app/Components/Shared/Loader/LoaderSlice';
import {replacePlaceholders} from '../../../../utilities/StringHelpers/TitleHelpers';
import {ChangePhoneNumberStep} from '../Constant/Constant';
import {setPhoneCodeForCallBack, setCurrentStep} from '../changePhoneNumberSlice';

const GeneralMessage = ({
  messageData,
  buttonClick,
  whiteButtonClick,
  linkAction,
  secondLinkAction,
  changePhoneNumber,
  userDetails,
  showAppLoader,
  hideAppLoader,
  iContent,
  setPhoneCodeForCallBack,
  setCurrentStep,
}) => {
  const {icon, title, secondTitle, buttonText, whiteButtonText, linkText, secondLinkText = false, contactUsButtons, report} = messageData;
  const contactUs = iContent.contactUsButtons?.expandedValue;
  const contactUsTitle = iContent.contactUsTitle?.value;

  const handleSubmit = (buttonAction) => {
    showAppLoader();
    if (buttonAction) {
      buttonAction();
    }
    hideAppLoader();
  };

  const handleCallbackClick = (code) => {
    setPhoneCodeForCallBack(code);
    setCurrentStep(ChangePhoneNumberStep.CallBack);
  };

  return (
    <div className='general-message-page step'>
      <Image src={icon} className='general-message-page-img' />
      <p className='l-title' dangerouslySetInnerHTML={{__html: replacePlaceholders(title, changePhoneNumber, false)}} />
      {secondTitle && (
        <p className='m-title' dangerouslySetInnerHTML={{__html: replacePlaceholders(secondTitle, changePhoneNumber, false)}} />
      )}
      {contactUsButtons && contactUs?.length > 0 && (
        <>
          {contactUsTitle && <p className='m-title'> {contactUsTitle}</p>}
          {contactUs.map((contact, index) => {
            return (
              <ContactUsAction
                key={index}
                contentData={contact}
                onCallBackClick={() => (contact.actionType.value === 'callback' ? handleCallbackClick(contact.phoneNumber.value) : null)}
              />
            );
          })}
        </>
      )}

      {linkText && (
        <div className='link-wrapper'>
          <a className='link' href='' onClick={() => handleSubmit(linkAction)}>
            {linkText}
          </a>
        </div>
      )}
      {secondLinkText && (
        <div className='link-wrapper second-link-wrapper'>
          <a className='link' href='' onClick={() => handleSubmit(secondLinkAction)}>
            {secondLinkText}
          </a>
        </div>
      )}

      <div className='continue-button'>
        {buttonText && <BtnSubmit text={buttonText} onclick={() => handleSubmit(buttonClick)} />}
        {whiteButtonText && (
          <BtnWhiteBlackBorderBigSize className={`second-button`} text={whiteButtonText} onclick={() => handleSubmit(whiteButtonClick)} />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  //userDetails: state.authentication?.loginData?.userDetails,
  changePhoneNumber: state.changePhoneNumber,
});

const mapDispatchToProps = {showAppLoader, hideAppLoader, setPhoneCodeForCallBack, setCurrentStep};
export default connect(mapStateToProps, mapDispatchToProps)(GeneralMessage);
